import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import useGradientStore from './gradientStore';
import { adjustColorLightness, assembleGradient, defaultGradient, hexToRgb, initialGradients, } from './gradientUtils';
import usePageStore from '../Page/pageStore';
import useDataStore from '../Data/dataStore';
import { useLocation } from 'react-router-dom';
import { getPath } from '../Router/Router';
import { isAndroid, MOBILE_SAFE_RESIZE } from '../globalUtils';
const defaultColor = '#FCFEFF';
const getTweenGradient = (gradient) => {
    return new Array(2).fill(null).reduce((acc, _, idx) => {
        const grad = gradient?.[idx];
        if (grad) {
            return [
                ...acc,
                { color: hexToRgb(grad.color), percentage: grad.percentage },
            ];
        }
        if (!grad && gradient) {
            if (gradient.length === 1) {
                return [
                    ...acc,
                    { color: hexToRgb(gradient[0].color), percentage: 100 },
                ];
            }
            if (gradient.length === 2) {
                return [
                    ...acc,
                    { color: hexToRgb(gradient[1].color), percentage: 100 },
                ];
            }
        }
        return [...acc, { color: 'rgb(255, 255, 255)', percentage: 100 }];
    }, []);
};
const GradientBox = () => {
    const urlPath = useLocation().pathname;
    const metaThemeColor = useRef(document.querySelector('meta[name="theme-color"]'));
    const { gradients, duration, ease } = useGradientStore();
    const { activePage, activeSection } = usePageStore();
    const dataState = useDataStore();
    const gradientRef = useRef();
    const activeSectionGrad = dataState.data[activePage]?.page_sections?.[activeSection]?.gradient;
    gradientRef.current = activeSectionGrad
        ? activeSectionGrad
        : activeSection < 0
            ? gradientRef.current
            : dataState.data[activePage]?.page_sections?.[0]?.gradient;
    const mainColorRef = useRef(hexToRgb(gradientRef.current?.[0]?.color ?? defaultColor));
    const mounted = useRef(false);
    const background = useRef([]);
    useEffect(() => {
        window.addEventListener(MOBILE_SAFE_RESIZE, onResizeEvent);
        return () => {
            window.removeEventListener(MOBILE_SAFE_RESIZE, onResizeEvent);
        };
    }, []);
    useEffect(() => {
        if (gradientRef.current) {
            handleNewGradient(gradientRef.current);
        }
        mounted.current = true;
    }, [JSON.stringify(gradientRef.current)]);
    const updateTweenThemeColor = () => {
        updateThemeColor(true);
    };
    const updateThemeColor = (isTween) => {
        const startColor = isAndroid || !isTween
            ? adjustColorLightness(mainColorRef.current)
            : mainColorRef.current;
        document.documentElement.style.setProperty('--mainColor', startColor);
        if (metaThemeColor.current) {
            metaThemeColor.current.setAttribute('content', startColor);
        }
    };
    const handleNewGradient = (dynamicBradient, init) => {
        const color1 = '#d8eef7';
        const color2 = '#fcfeff';
        //const metaThemeColor = document.querySelector('meta[name="theme-color"]');
        if (metaThemeColor) {
            document.documentElement.style.setProperty('--mainColor', color1);
            if (metaThemeColor.current) {
                metaThemeColor.current.setAttribute('content', color1);
                const grad = assembleGradient([
                    { color: color1, percentage: 0 },
                    { color: color2, percentage: 100 },
                ]);
                document.body.style.setProperty('--gradient', grad);
            }
        }
        /* const mainColor = adjustColorLightness(
          hexToRgb(gradient?.[0]?.color ?? defaultColor),
        );
        const metaThemeColor = document.querySelector('meta[name="theme-color"]');
        if (metaThemeColor) {
          if (init) {
            mainColorRef.current = mainColor;
            updateThemeColor();
          } else {
            gsap.killTweensOf(mainColorRef);
            gsap.to(mainColorRef, {
              current: mainColor,
              duration,
              ease,
              onUpdate: updateTweenThemeColor,
            });
          }
        }
    
        const rawGrad = getTweenGradient(gradient);
        const newGrad = [
          { ...rawGrad[0], color: adjustColorLightness(rawGrad[0].color) },
          rawGrad[1],
        ];
    
        if (init) {
          background.current = newGrad;
          applyGradients();
        } else {
          gsap.to(background.current, {
            current: newGrad,
            duration,
            ease,
            color: (i: number) => {
              return newGrad[i].color;
            },
            percentage: (i: number) => {
              return newGrad[i].percentage;
            },
            onUpdate: applyTweenGradients,
          });
        } */
    };
    const applyGradients = (isTween) => {
        if (background.current) {
            // IF it's not android && not tween, we return the original color while tween occurs
            const startColor = isAndroid || !isTween
                ? adjustColorLightness(background.current[0].color)
                : background.current[0].color;
            const safeColors = [
                {
                    ...background.current[0],
                    color: startColor,
                },
                background.current[1],
            ];
            const grad = assembleGradient(safeColors);
            document.body.style.setProperty('--gradient', grad);
        }
    };
    const onResizeEvent = () => {
        document.dispatchEvent(new CustomEvent('gradient', { detail: { resize: true } }));
    };
    if (!mounted.current) {
        const grad = initialGradients[getPath(urlPath)] ?? defaultGradient;
        handleNewGradient(grad, true);
    }
    return _jsx("div", { className: "gradient-container" });
};
export default GradientBox;
